import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ExternalLink, X } from 'lucide-react';
import './AdVideoPlaybackModal.css';

export default function AdVideoPlaybackModal({ ad, onClose }) {
  const videoRef = useRef(null);
  const [playbackFailed, setPlaybackFailed] = useState(false);

  const title = ad?.title || ad?.headline || 'Ad video';
  const libraryUrl = ad?.adLibraryUrl || ad?.ctaLink || null;

  useEffect(() => {
    setPlaybackFailed(false);
  }, [ad?.videoPlaybackUrl]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const handleBackdropClick = useCallback((event) => {
    if (event.target === event.currentTarget) onClose();
  }, [onClose]);

  return (
    <div
      className="ad-video-modal-backdrop"
      role="presentation"
      onClick={handleBackdropClick}
    >
      <div
        className="ad-video-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ad-video-modal-title"
      >
        <header className="ad-video-modal__head">
          <h2 id="ad-video-modal-title" className="ad-video-modal__title">{title}</h2>
          <button
            type="button"
            className="ad-video-modal__close nodrag"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </header>
        <div className="ad-video-modal__body">
          {!playbackFailed && ad?.videoPlaybackUrl ? (
            <video
              ref={videoRef}
              className="ad-video-modal__player"
              src={ad.videoPlaybackUrl}
              controls
              playsInline
              preload="metadata"
              referrerPolicy="no-referrer"
              onError={() => setPlaybackFailed(true)}
            />
          ) : (
            <div className="ad-video-modal__fallback">
              <p>This video cannot be played in the app (link may have expired).</p>
              {libraryUrl ? (
                <a
                  href={libraryUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ad-video-modal__library-link"
                >
                  <ExternalLink size={14} aria-hidden />
                  Open in Ad Library
                </a>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
